import React, { useEffect } from 'react';
import classNames from 'classnames';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import useMobileLayout from 'Hooks/useMobileLayout';
import ResourceSummaryCard from 'Components/ComponentLibrary/Components/Uncategorized/ResourceSummaryCard';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { plaidModal } from 'Consts/plaid';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import { DS_SIZE_MAP } from 'Components/ComponentLibrary/DesignSystem/sizes';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import LinkIcon from '@material-ui/icons/Link';


const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: plaidModal.width,
    height: '88vh',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  body: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  footer: {
    width: '100%',
    position: 'sticky',
    bottom: 0,
  },
  rootDesktop: {
    maxWidth: '600px',
    maxHeight: plaidModal.maxHeight,
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(3),
  },
  subtitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(3.5),
  },
  linkIconContainer: {
    borderRadius: '50%',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.facet.accentGreen11,
  },
  linkIcon: {
    color: theme.palette.success.main,
    fontSize: 40,
  },
  success: {
    color: theme.palette.success.main,
  },
}));

const ApexFundingAccountResultStep = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const { refreshPageContentCollection } = usePageContentContext();
  const { clearModalCollection } = useModalContext();
  const success = resource.attr('status') === 'APPROVED';

  useEffect(() => {
    return () => {
      refreshPageContentCollection();
    };
  }, []);

  const classes = useStyles();

  return (
    <Box className={classNames(classes.root, { [classes.rootDesktop]: !isMobile })}>
      <Box className={classes.body}>
        <Title
          className={classNames(classes.title, {
            [classes.success]: success,
          })}
          text={resource.attr('title')}
          test={'wizard-step-title'}
        />
        {success && (
          <Box className={classes.linkIconContainer}>
            <LinkIcon
              className={classes.linkIcon}
            />
          </Box>
        )}
        <Subtitle className={classes.subtitle} text={resource.attr('subtitle')} test={'wizard-step-subtitle'} />
        <ResourceSummaryCard resource={resource.attr('account').resources().head()} />
      </Box>
      <Box className={classes.footer}>
        <RoundedButton
          test="next-step"
          onClick={clearModalCollection}
          className={classes.nextButton}
          variant="contained"
          color={'primary'}
          fullWidth
          size={DS_SIZE_MAP.sm}
        >
          {'Continue'}
        </RoundedButton>
      </Box>
    </Box>
  );
};

ApexFundingAccountResultStep.propTypes = {
};

export default ApexFundingAccountResultStep;
